var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", [
        _vm._v("\n\t\t" + _vm._s(_vm.t("health", "Weight", {})) + "\n\t")
      ]),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "\n\t\t" + _vm._s(_vm.t("health", "Body mass index (BMI)")) + "\n\t"
        )
      ]),
      _vm._v(" "),
      !_vm.loading
        ? _c("div", [
            !_vm.minWeightDataset || !_vm.person.size || !_vm.person.age
              ? _c("div", [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(
                        _vm.t(
                          "health",
                          "To calculate your BMI, please set your weight in the table below and you age and size in the person settings."
                        )
                      ) +
                      "\n\t\t"
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-1 hide-s" },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.t("health", "minimum", {})) +
                      "\n\t\t\t\t"
                  ),
                  _vm.minWeightDataset && _vm.person.size && _vm.person.age
                    ? _c("WeightBmi", {
                        attrs: {
                          title: _vm.t("health", "minimum"),
                          date: _vm.minWeightDataset
                            ? _vm.minWeightDataset.date
                            : null,
                          weight: _vm.minWeightDataset
                            ? _vm.minWeightDataset.weight
                            : null,
                          person: _vm.person
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-1",
                  staticStyle: { "font-weight": "bold" }
                },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.t("health", "actual", {})) +
                      "\n\t\t\t\t"
                  ),
                  _vm.minWeightDataset && _vm.person.size && _vm.person.age
                    ? _c("WeightBmi", {
                        attrs: {
                          title: _vm.t("health", "actual"),
                          "show-base-info": false,
                          date: _vm.lastWeightDataset
                            ? _vm.lastWeightDataset.date
                            : null,
                          weight: _vm.lastWeightDataset
                            ? _vm.lastWeightDataset.weight
                            : null,
                          person: _vm.person
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-1 hide-s" },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.t("health", "maximum", {})) +
                      "\n\t\t\t\t"
                  ),
                  _vm.minWeightDataset && _vm.person.size && _vm.person.age
                    ? _c("WeightBmi", {
                        attrs: {
                          title: _vm.t("health", "maximum"),
                          "show-base-info": false,
                          date: _vm.maxWeightDataset
                            ? _vm.maxWeightDataset.date
                            : null,
                          weight: _vm.maxWeightDataset
                            ? _vm.maxWeightDataset.weight
                            : null,
                          person: _vm.person
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(
              "\n\t\t" +
                _vm._s(
                  _vm.t(
                    "health",
                    "The calculated value is valid only for adults. Its base are the tables from the WHO."
                  )
                ) +
                "\n\t"
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.loading ? _c("div", { staticClass: "icon-loading" }) : _vm._e(),
      _vm._v(" "),
      _c("h3", [_vm._v("Target")]),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "div",
            [
              _vm.lastWeight &&
              _vm.weightTarget &&
              _vm.weightTargetInitialWeight &&
              _vm.weightTarget <= _vm.weightTargetInitialWeight
                ? _c("TextResultsLooseWeight", {
                    attrs: {
                      bounty: _vm.weightTargetBounty,
                      "initial-weight": _vm.weightTargetInitialWeight,
                      target: _vm.weightTarget,
                      weight: _vm.lastWeight,
                      unit: _vm.weightUnit
                    }
                  })
                : _vm.lastWeight &&
                  _vm.weightTarget &&
                  _vm.weightTargetInitialWeight &&
                  _vm.weightTarget > _vm.weightTargetInitialWeight
                ? _c("TextResultsGainWeight", {
                    attrs: {
                      bounty: _vm.weightTargetBounty,
                      "initial-weight": _vm.weightTargetInitialWeight,
                      target: _vm.weightTarget,
                      weight: _vm.lastWeight,
                      unit: _vm.weightUnit
                    }
                  })
                : _c("TextResultsNoData")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loading ? _c("div", { staticClass: "icon-loading" }) : _vm._e(),
      _vm._v(" "),
      _c("h3", [_vm._v(_vm._s(_vm.t("health", "Chart", {})))]),
      _vm._v(" "),
      !_vm.loading
        ? _c("WeightChart", {
            attrs: { person: _vm.person, data: _vm.weightData }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loading ? _c("div", { staticClass: "icon-loading" }) : _vm._e(),
      _vm._v(" "),
      _c("h3", [_vm._v("Data")]),
      _vm._v(" "),
      !_vm.loading
        ? _c("WeightTable", {
            attrs: { data: _vm.weightData, person: _vm.person }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loading ? _c("div", { staticClass: "icon-loading" }) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }